import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import _ from 'lodash';
import UploadPictureRegister from '../../components/UploadPictureRegister';
import { constHelper } from '../../constants/objects.constants';
import {
  hasClienteComPA,
  isAdmin,
  isAdminBio,
  isAprovador,
  isPedidoAvulso,
  isSolicitante,
  isSudo,
} from '../../helpers/permissions.helper';

import {
  FaBusinessTime,
  FaRegListAlt,
  FaUsers,
  FaLayerGroup,
} from 'react-icons/fa';
import { MdAddBusiness, MdOutlineBlock } from 'react-icons/md';
import { TbFileImport, TbTableImport } from 'react-icons/tb';
import { LuLayoutDashboard } from 'react-icons/lu';
import { CgProductHunt } from 'react-icons/cg';
import { GiReturnArrow } from 'react-icons/gi';

const Core = require('../../js/sidePluguin');

const options = {
  duration: 300,
  timer: 500,
  timerCurto: 300,
  timerLongo: 2000,
  resizeWnd: 1000,
};

const allMenus = [
  {
    key: 'dashboard',
    to: '/dashboard',
    icon: <LuLayoutDashboard size={18} style={{ marginRight: 10 }} />,
    label: 'Painel de Situação',
  },
  {
    key: 'notas',
    to: '/notas',
    icon: <TbFileImport size={18} style={{ marginRight: 10 }} />,
    label: 'Importar Nota Fiscal',
  },
  {
    key: 'cliente',
    to: '/cliente',
    icon: <FaBusinessTime size={18} style={{ marginRight: 10 }} />,
    label: 'Clientes',
  },
  {
    key: 'usuario',
    to: '/usuario',
    icon: <FaUsers size={18} style={{ marginRight: 10 }} />,
    label: 'Usuários',
  },
  {
    key: 'pedidos',
    to: '/pedidos',
    icon: <FaRegListAlt size={15} style={{ marginRight: 10 }} />,
    label: 'Pedidos',
  },
  {
    key: 'importPedidos',
    to: '/importarPedido',
    icon: <TbTableImport size={18} style={{ marginRight: 10 }} />,
    label: 'Importar Pedidos',
  },
  {
    key: 'pedidoEmMapa',
    to: '/pedidoEmMapa',
    icon: <FaLayerGroup size={18} style={{ marginRight: 10 }} />,
    label: 'Pedido em Mapa',
  },
  {
    key: 'pedidoDevolucao',
    to: '/pedidoDevolucao',
    icon: <GiReturnArrow size={18} style={{ marginRight: 10 }} />,
    label: 'Pedido de Devolução',
  },

  {
    key: 'mapaProdutos',
    to: '/mapaProdutos',
    icon: <CgProductHunt size={18} style={{ marginRight: 10 }} />,
    label: 'Mapa de Produtos',
  },
  {
    key: 'produtoBloqueado',
    to: '/produtoBloqueado',
    icon: <MdOutlineBlock size={18} style={{ marginRight: 10 }} />,
    label: 'Bloqueio de Produtos',
  },
  {
    key: 'pontoAtendimento',
    to: '/pontoAtendimento',
    icon: <MdAddBusiness size={18} style={{ marginRight: 10 }} />,
    label: 'Ponto de Atendimento',
  },
];

const getPermissionMap = (user) => ({
  dashboard: isSudo(user) || isAdminBio(user),
  notas: isSudo(user) || isAdminBio(user),
  cliente: isSudo(user),
  usuario: (isAdmin(user) && hasClienteComPA(user)) || isSudo(user),
  pedidos:
    isAdmin(user) ||
    isSudo(user) ||
    isAprovador(user) ||
    isSolicitante(user) ||
    isAdminBio(user),
  importPedidos: (isAdmin(user) && hasClienteComPA(user)) || isSudo(user),
  pedidoDevolucao:
    (hasClienteComPA(user) || isSudo(user)) && !isSolicitante(user),
  pedidoEmMapa: (hasClienteComPA(user) || isSudo(user)) && !isSolicitante(user),
  mapaProdutos: (isAdmin(user) && hasClienteComPA(user)) || isSudo(user),
  produtoBloqueado: (isAdmin(user) && hasClienteComPA(user)) || isSudo(user),
  pontoAtendimento: (isAdmin(user) && hasClienteComPA(user)) || isSudo(user),
});

class Menu extends React.Component {
  el = null;

  constructor(props) {
    super(props);
    this.state = {
      formaPagamento: {},
    };
  }

  componentDidMount() {
    const core = new Core(this.el, options, document.body, null, window);
    core.init();
  }

  getDataUrl = (entity) => {
    return entity.foto && !entity.foto.id && entity.foto.data
      ? entity.foto.data
      : null;
  };

  changeImage = (imageVO) => {
    console.log(imageVO);
  };

  render() {
    const { user } = this.props;
    const permissionMap = getPermissionMap(user);
    const showConfig = isSudo(user);

    const menuItems = allMenus.filter((item) => permissionMap[item.key]);

    return (
      <div className="sidebar sidebar-hide-to-small sidebar-shrink">
        <div className="nano" ref={(el) => (this.el = el)}>
          <div className="nano-content">
            <div className="iconeCollapse sidebar-toggle">
              <img
                src={require('../../img/icon_closeBlack.svg')}
                alt="Fechar modal"
              />
            </div>

            <div className="logo">
              <div className="logoMarca" />
            </div>

            <div className="perfil">
              <div className="imgPerfil my-2">
                <UploadPictureRegister
                  name="foto"
                  hideLabel
                  onChange={this.changeImage}
                  idImage={user.foto ? user.foto.id : null}
                  dataUrl={this.getDataUrl(user)}
                  id="foto"
                />
              </div>

              <div className="dadosPerfil row justify-content-center mt-2">
                <div className="text-center">
                  <h3 className="mb-3">
                    {user.nomeExibicao !== 'null '
                      ? user.nomeExibicao
                      : user.email}
                  </h3>
                  <p className="cargo mt-n1">{_.get(constHelper, user.role)}</p>

                  {showConfig && (
                    <button
                      type="button"
                      id="btnConfig"
                      className="btn btn-primary btn-sm"
                      onClick={() =>
                        this.props.history.push('/configuracoes/view/')
                      }
                    >
                      Configurações
                    </button>
                  )}
                </div>
              </div>
            </div>

            <ul className="menu">
              {menuItems.map((item, index) => (
                <li key={item.key} className={index % 2 === 0 ? 'zebra' : ''}>
                  <NavLink className="link" to={item.to}>
                    {item.icon}
                    {item.label}
                  </NavLink>
                </li>
              ))}
              <li className="link">
                <button
                  type="button"
                  onClick={this.props.logoff}
                  className="btn-reset-style"
                >
                  <i className="icon-logoff" /> Sair do sistema
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.authentication.user,
  };
}

const mapDispatch = ({ authentication: { logoff } }) => ({
  logoff: () => logoff(),
});

const connectedMenu = withRouter(
  connect(
    mapStateToProps,
    mapDispatch
  )(Menu)
);
export { connectedMenu as Menu };
